export default "__VITE_ASSET__Bbokfm2$__"